
import SearchComponent from './POISearch/SearchComponent';
import DistrictSearchComponent from './DistrictSearch/DistrictSearchComponent';

export default {
    // POI搜索组件
    SearchComponent,
    DistrictSearchComponent,
    // demo组件
    // DemoComponent
};

